import { supabase } from '../lib/supabase'
import { QgNumerosRow } from '../types/qgNumeros'

// Serviço da seção "Números do PASI QG" no dashboard principal.
// Lê a view materializada public.mv_qg_dashboard_kpis (atualizada pelo DBA/job).
export const qgNumerosService = {
  // Busca a única linha da MV (indicadores agregados diários).
  async fetchNumeros(): Promise<QgNumerosRow | null> {
    const { data, error } = await supabase
      .from('mv_qg_dashboard_kpis')
      .select('*')
      .maybeSingle()

    if (error) throw error
    return (data as QgNumerosRow | null) ?? null
  },
}
